angular.module('erp.other.membershipService').run(['$templateCache', function($templateCache) {
  $templateCache.put("tpl/outbox.htm",
    "<div class=\"mainoverall-style-membershipService\">\n" +
    "    <div class=\"container-fluid\">\n" +
    "        <div class=\"alert alert-warning alert-mini\" ng-if=\"vm.alertShow1\">\n" +
    "            <button type=\"button\" class=\"close\" ng-click=\"vm.alertShow1=false\">&times;</button>\n" +
    "            <strong>特别说明：</strong><strong class=\"alert-red\">「速卖通服务」</strong>如：扩充店铺数或续期使用等服务，请<a href=\"https://marketplace.aliexpress.com/web/detail.html?articleCode=FW_GOODS-1000698176\" target=\"_blank\">移至官方应用市场购买</a>。\n" +
    "            <strong class=\"alert-red\">【图片翻译】【文本翻译】</strong>请至<a ng-click=\"vm.payserviceextend()\">扩展VIP</a>购买。\n" +
    "            <span class=\"grey\">(此购买不包含VIP服务)</span>\n" +
    "        </div>\n" +
    "        <div class=\"mui-container no-scrollfix\">\n" +
    "            <div class=\"table-box\">\n" +
    "                <div class=\"table-str\">\n" +
    "                    <table class=\"table table-bordered table-vmiddle text-center table2 margin-b0\" style=\"background-color: #ffffff;\">\n" +
    "                        <tbody>\n" +
    "                            <tr>\n" +
    "                                <td width=\"12.5%\">\n" +
    "                                    <div>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                                <td width=\"12.5%\" class=\"pos-rel\">\n" +
    "                                    <p class=\"vip-title\">\n" +
    "                                        <img ng-src=\"//asset.mangoerp.com/img/icon/vip-free.png\" class=\"vipicon\">\n" +
    "                                        免费版\n" +
    "                                    </p>\n" +
    "                                    <p class=\"text-muted\">永久免费使用</p>\n" +
    "                                </td>\n" +
    "                                <td width=\"12.5%\" ng-repeat=\"item in vm.vipList\" class=\"pos-rel\" ng-class=\"['vip-bg-' + item.businessType]\">\n" +
    "                                    {{item.businessType}}\n" +
    "                                    <img ng-if=\"item.businessType==='vip0'\" ng-src=\"//asset.mangoerp.com/img/icon/vip-tip-time-icon.png\" class=\"vip-tip-time-icon\">\n" +
    "                                    <img ng-src=\"//asset.mangoerp.com/img/icon/{{item.businessType}}-tip-icon.png\" class=\"vip-tip-icon\">\n" +
    "                                    <!-- <img ng-if=\"!vm.inActivity && (item.businessType==='vip2' || item.businessType==='vip3')\" src=\"//asset.mangoerp.com/img/icon/viphot-icon.png\" class=\"viphot\"> -->\n" +
    "                                    <p class=\"vip-title\" style=\"margin-top: 20px;\">\n" +
    "                                        <img ng-src=\"//asset.mangoerp.com/img/icon/{{item.businessType}}-new-icon.png\" class=\"vipicon\"> {{item.title}}\n" +
    "                                    </p>\n" +
    "                                    <p>\n" +
    "                                        <ul class=\"list-unstyled vip-price-box\">\n" +
    "                                            <li ng-repeat=\"child in item.list\" ng-if=\"$first\">\n" +
    "                                                <span>￥<span class=\"unit-pay-text\">{{child.unitPay}}</span></span>/{{child.durationUnitMount}}天\n" +
    "                                                <p ng-if=\"item.businessType == 'vip0'\" class=\"text-muted\" style=\"text-decoration: line-through;\">￥188/30天</p>\n" +
    "                                                <!-- <span ng-if=\"child.extraDays\" style=\"color:indianred;font-weight: bold;font-size:1.2em;\">\n" +
    "                                                    赠{{child.extraDays}}天</span> -->\n" +
    "                                            </li>\n" +
    "                                        </ul>\n" +
    "                                    </p>\n" +
    "                                    <button type=\"button\" class=\"btn btn-vip btn-trans btn-success\" ng-click=\"vm.pay()\">立即购买</button>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "                <table class=\"table table-bordered table-vmiddle table1\" ng-repeat=\"item in vm.list\" ng-if=\"item.values.length\">\n" +
    "                    <tbody>\n" +
    "                        <tr class=\"tr-title\" ng-if=\"vm.expired && vm.expired.list && $index==0\">\n" +
    "                            <td width=\"12.5%\" class=\"bigger-120\">\n" +
    "                                <i class=\"fa fa-tag\"></i>\n" +
    "                                <span class=\"margin-l1\">我的优惠券</span>\n" +
    "                            </td>\n" +
    "                            <td colspan=\"7\">\n" +
    "                                <ul class=\"coupon-list\">\n" +
    "                                    <li ng-repeat=\"item in vm.expired.list\" ng-class=\"{'expired':!(item.isUsed=='n'&&item.isExpired!='y')}\">\n" +
    "                                        <i class=\"corner-left\"></i>\n" +
    "                                        <i class=\"corner-middle\"></i>\n" +
    "                                        <i class=\"corner-right\"></i>\n" +
    "                                        <div class=\"coupon-left\">\n" +
    "                                            <i>￥</i>\n" +
    "                                            <strong>{{item.amount}}</strong>\n" +
    "                                            <b>代金券\n" +
    "                                                <span>仅限年付vip</span>\n" +
    "                                                <!-- <span>优先使用最高金额</span> -->\n" +
    "                                            </b>\n" +
    "                                            <p>有效期<span ng-if=\"item.beginTime\">{{item.beginTime|date:\"yyyy-MM-dd\"}}</span>至<span>{{item.expiredTime|date:\"yyyy-MM-dd\"}}</span></p>\n" +
    "                                        </div>\n" +
    "                                        <div class=\"coupon-right\">\n" +
    "                                            <span ng-if=\"item.isUsed=='y'\">已使用</span>\n" +
    "                                            <span ng-if=\"item.isUsed=='n'\">\n" +
    "                                                <span ng-if=\"item.isStart!='y'\">未开始</span>\n" +
    "                                                <span ng-if=\"item.isStart=='y'\">\n" +
    "                                                    <span ng-if=\"item.isExpired!='y'\">有效</span>\n" +
    "                                                    <span ng-if=\"item.isExpired=='y'\">已过期</span>\n" +
    "                                                </span>\n" +
    "                                            </span>\n" +
    "                                        </div>\n" +
    "                                    </li>\n" +
    "                                </ul>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr class=\"tr-title\">\n" +
    "                            <td width=\"12.5%\" class=\"bigger-120\">\n" +
    "                                <i class=\"fa fa-tag\"></i>\n" +
    "                                <span class=\"margin-l1\">{{item.title}}</span>\n" +
    "                            </td>\n" +
    "                            <td colspan=\"7\">\n" +
    "                                <!-- <span ng-if=\"item.title==='通用服务'\" class=\"special light-grey\">\n" +
    "                                    <strong>特别说明：</strong> VIP服务请在此页面购买。「速卖通服务」如：扩充店铺数或续期使用等，服务购买\n" +
    "                                    <a href=\"https://marketplace.seller.aliexpress.com/detail.html?code=FW_GOODS-1000698176\" target=\"_blank\">请移至官方应用市场</a>\n" +
    "                                </span> -->\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- 产品发布 -->\n" +
    "                        <tr ng-if=\"item.title === '产品刊登'\">\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span class=\"margin-l4\">\n" +
    "                                    产品发布\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <div>\n" +
    "                                    Lazada：店铺数*10/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    Shopee：10个/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    Shopee全托：10个/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    MercadoLibre：10个/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    TikTok全托管：10个/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    allegro：10个/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    Temu全/半：10个/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    Shein半托管：10个/每天\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    其他免费平台:\n" +
    "                                    <span class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                        <i class=\"fa fa-check\"></i>\n" +
    "                                    </span>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <div>\n" +
    "                                    MercadoLibre：5000个/月\n" +
    "                                </div>\n" +
    "                                <span class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-repeat=\"child in item.values | orderBy : 'seq'\" ng-if=\"child.isOpened==='y' || child.isOpened==='s'\">\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span class=\"margin-l4\">\n" +
    "                                    {{child.serivcePointName}}\n" +
    "                                    <span tooltip=\"{{child.note}}\" ng-if=\"child.note && child.serivcePointName!=='其它店铺数'\">\n" +
    "                                        <!-- <i class=\"fa fa-exclamation-circle light-grey bigger-120\"></i> -->\n" +
    "                                    </span>\n" +
    "                                    <div ng-if=\"child.note && child.serivcePointName==='其它店铺数'\" ng-bind-html=\"child.note | noteShopFilter\">\n" +
    "                                    </div>\n" +
    "                                    <span class=\"badge badge-danger pos-abs line-height-1 margin-l1\" ng-if=\"child.serviceNew==='y'\">new</span>\n" +
    "                                </span>\n" +
    "                                <!-- 增加产品提示 -->\n" +
    "                                <span tooltip=\"包括产品管理中的模块数以及水印模版管理数\" ng-if=\"child.serivcePointName === '产品模块'\">\n" +
    "                                    <!-- <i class=\"fa fa-exclamation-circle light-grey bigger-120\"></i> -->\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span ng-if=\"child.normal==='limitless'\" class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.normal==='no'\" tooltip=\"不可用\">\n" +
    "                                    --\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.normal==='limit'\">\n" +
    "                                    {{child.normalLimit}}\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.normal==='limit' && child.normalLimitUnit\">\n" +
    "                                    （{{child.normalLimitUnit}}）\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span ng-if=\"child.vip0==='limitless'\" class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip0==='no'\" tooltip=\"不可用\">\n" +
    "                                    --\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip0==='limit'\">\n" +
    "                                    {{child.vip0Limit}}\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip0==='limit' && child.vip0LimitUnit\">\n" +
    "                                    （{{child.vip0LimitUnit}}）\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span ng-if=\"child.vip1==='limitless'\" class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip1==='no'\" tooltip=\"不可用\">\n" +
    "                                    --\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip1==='limit'\">\n" +
    "                                    {{child.vip1Limit}}\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip1==='limit' && child.vip1LimitUnit\">\n" +
    "                                    （{{child.vip1LimitUnit}}）\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span ng-if=\"child.vip2==='limitless'\" class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip2==='no'\" tooltip=\"不可用\">\n" +
    "                                    --\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip2==='limit'\">\n" +
    "                                    {{child.vip2Limit}}\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip2==='limit' && child.vip2LimitUnit\">\n" +
    "                                    （{{child.vip2LimitUnit}}）\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span ng-if=\"child.vip3==='limitless'\" class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip3==='no'\" tooltip=\"不可用\">\n" +
    "                                    --\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip3==='limit'\">\n" +
    "                                    {{child.vip3Limit}}\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip3==='limit' && child.vip3LimitUnit\">\n" +
    "                                    （{{child.vip3LimitUnit}}）\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span ng-if=\"child.vip4==='limitless'\" class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip4==='no'\" tooltip=\"不可用\">\n" +
    "                                    --\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip4==='limit'\">\n" +
    "                                    {{child.vip4Limit}}\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip4==='limit' && child.vip4LimitUnit\">\n" +
    "                                    （{{child.vip4LimitUnit}}）\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td width=\"12.5%\">\n" +
    "                                <span ng-if=\"child.vip5==='limitless'\" class=\"limitless\" tooltip=\"无限制\">\n" +
    "                                    <i class=\"fa fa-check\"></i>\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip5==='no'\" tooltip=\"不可用\">\n" +
    "                                    --\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip5==='limit'\">\n" +
    "                                    {{child.vip5Limit}}\n" +
    "                                </span>\n" +
    "                                <span ng-if=\"child.vip5==='limit' && child.vip5LimitUnit\">\n" +
    "                                    （{{child.vip5LimitUnit}}）\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "                <br>\n" +
    "                <br>\n" +
    "                <br>\n" +
    "                <br>\n" +
    "                <br>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-backdropmembershipService\" ng-if=\"vm.trueBox\">\n" +
    "    <mg-box class=\"modal-dialogmembershipService\">\n" +
    "        <div class=\"modal-header\">\n" +
    "            <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button>\n" +
    "            <h3 class=\"modal-title\">\n" +
    "                登录提醒\n" +
    "            </h3>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body clearfix\">\n" +
    "            您尚未登录，只有登录状态下才能购买VIP服务\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.save()\">去登录</button>\n" +
    "            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button>\n" +
    "        </div>\n" +
    "    </mg-box>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);
